"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getiOSDeviceType = exports.getMobileiOSBrowser = exports.getMobileDevice = void 0;

var _exenv = _interopRequireDefault(require("exenv"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getMobileDevice = function getMobileDevice() {
  if (!_exenv["default"].canUseDOM) {
    return 'unknown';
  }

  var userAgent = navigator.userAgent || navigator.vendor || window.opera; // Windows Phone must come first because its UA also contains "Android"

  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  } // iOS detection from: http://stackoverflow.com/a/9039885/177710


  if ((/iPad|iPhone|iPod/.test(userAgent) || navigator.userAgent.includes('Mac') && 'ontouchend' in document) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
};

exports.getMobileDevice = getMobileDevice;

var getMobileiOSBrowser = function getMobileiOSBrowser() {
  if (!_exenv["default"].canUseDOM) {
    return 'unknown';
  }

  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if ((/iPad|iPhone|iPod/.test(userAgent) || navigator.userAgent.includes('Mac') && 'ontouchend' in document) && !window.MSStream) {
    if (/CriOS/.test(userAgent)) {
      return 'Chrome';
    }

    return 'Safari';
  }

  return 'unknown';
};

exports.getMobileiOSBrowser = getMobileiOSBrowser;

var getiOSDeviceType = function getiOSDeviceType() {
  if (!_exenv["default"].canUseDOM) {
    return 'unknown';
  }

  if (getMobileDevice() === 'iOS') {
    if (screen.availHeight === 812 && screen.availWidth === 375) {
      return 'TALL';
    }

    return 'SHORT';
  }

  return 'unknown';
};

exports.getiOSDeviceType = getiOSDeviceType;